/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { getStorageValue } from "../../service/shared.service";
import "../../style/layout.scss";
import {
  dashboard,
  businesses,
  Credee_Logo,
  companyLogo,
  calculator,
  subPartner,
  tier1,
  support,
  PayoutReport,
  searchinput,
  missingInfo,
  dummy_profile_pic,
  courses,
  assets,
} from "../../assets/assets";
import { useDispatch, useSelector } from "react-redux";
import toastr from "./toast";
import { Graph } from "../Dashboard/Graph";
import { showdropdown, showGraph } from "../../Redux/Slices/MainSlice";

const Layout = () => {
  const dispatch = useDispatch();
  const graphShow = useSelector((state: any) => state?.APIData?.graphShow);
  const commisionData = useSelector((state: any) => state?.APIData?.getCommisionsData);
  // console.log(commisionData,"commisionDatacommisionDatacommisionData");
  

  const commisions = getStorageValue("paymentData");
  const toastrService = new toastr(true);
  const stripe = useSelector((state: any) => {
    const partnerData = state?.APIData?.partnerData;
    return partnerData && [partnerData].length > 0 ? partnerData : null;
  });
  let [image, setImage] = useState(dummy_profile_pic);
  const stripeData = stripe && stripe.stripe_data;
  // console.log(partnerInfo,"stripestripe");
  const partnerInfo = getStorageValue("partnerData");
  const profileData = useSelector((state: any) => {
    return state?.APIData?.partnerData;
  });
  const routes = {
    dashboard: "dashboard",
    business: "business",
    calculator: "calculator",
  };
// console.log(stripe);

  let [activeRoute, updateActiveRouteState] = useState("dashboard");
  const navigate = useNavigate();
  let [searchInput, setSearchInput] = useState("");
  let userData = useSelector((state: any) => state?.APIData?.partnerData);
  let graphData = useSelector((state: any) => state?.APIData?.graphData);
  const updateActiveRoute = (activeRouteName: string) => {
    updateActiveRouteState(activeRouteName);
    navigate("/" + activeRoute);
  };
  const [showGraphVal, setShowGraphVal] = useState(false);

  useEffect(() => {
    if (window.location.pathname == "/partner/app/dashboard") {
      searchInput = "";
      setSearchInput(searchInput);
    }
    if (
      profileData &&
      profileData.partner_profile &&
      profileData.partner_profile.length
    ) {
      setImage(profileData.partner_profile[0].partner_image);
    } else if (
      userData &&
      userData.partnerProfile &&
      userData.partnerProfile[0] &&
      userData.partnerProfile[0].partner_image
    ) {
      setImage(userData.partnerProfile[0].partner_image);
    } else {
      setImage(dummy_profile_pic);
    }
    // if (userData &&
    //   userData.partnerProfile &&
    //   userData.partnerProfile[0] &&
    //   userData.partnerProfile[0].partner_image) {
    //     image = userData.partnerProfile[0].partner_image;
    //     setImage(image);
    //   }
  }, [window.location.pathname, profileData]);

  const countData = useSelector(
    (state: any) => state?.APIData?.agentBusinessCount
  );
  const deleteData = () => {
    searchInput = "";
    setSearchInput(searchInput);
    setTimeout(() => {
      navigate("/app/dashboard");
    }, 200);
  };

  return (
    <>
      {getStorageValue("partnerToken") ? (
        <div className="nav-top">
          
          { profileData && profileData.partner_profile && profileData.partner_profile.length && profileData.partner_profile[0] && profileData.partner_profile[0].share_type == 1 && !graphShow && commisionData &&(commisionData.payments?.upcoming_revenue > 0 || commisionData.payments?.total_revenue > 0) && (
            <div
            className={`show-graph-btn`}
            onClick={() => {dispatch(showGraph(!graphData));}}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM7.63 18.15C7.63 18.56 7.29 18.9 6.88 18.9C6.47 18.9 6.13 18.56 6.13 18.15V16.08C6.13 15.67 6.47 15.33 6.88 15.33C7.29 15.33 7.63 15.67 7.63 16.08V18.15ZM12.75 18.15C12.75 18.56 12.41 18.9 12 18.9C11.59 18.9 11.25 18.56 11.25 18.15V14C11.25 13.59 11.59 13.25 12 13.25C12.41 13.25 12.75 13.59 12.75 14V18.15ZM17.87 18.15C17.87 18.56 17.53 18.9 17.12 18.9C16.71 18.9 16.37 18.56 16.37 18.15V11.93C16.37 11.52 16.71 11.18 17.12 11.18C17.53 11.18 17.87 11.52 17.87 11.93V18.15ZM17.87 8.77C17.87 9.18 17.53 9.52 17.12 9.52C16.71 9.52 16.37 9.18 16.37 8.77V7.8C13.82 10.42 10.63 12.27 7.06 13.16C7 13.18 6.94 13.18 6.88 13.18C6.54 13.18 6.24 12.95 6.15 12.61C6.05 12.21 6.29 11.8 6.7 11.7C10.07 10.86 13.07 9.09 15.45 6.59H14.2C13.79 6.59 13.45 6.25 13.45 5.84C13.45 5.43 13.79 5.09 14.2 5.09H17.13C17.17 5.09 17.2 5.11 17.24 5.11C17.29 5.12 17.34 5.12 17.39 5.14C17.44 5.16 17.48 5.19 17.53 5.22C17.56 5.24 17.59 5.25 17.62 5.27C17.63 5.28 17.63 5.29 17.64 5.29C17.68 5.33 17.71 5.37 17.74 5.41C17.77 5.45 17.8 5.48 17.81 5.52C17.83 5.56 17.83 5.6 17.84 5.65C17.85 5.7 17.87 5.75 17.87 5.81C17.87 5.82 17.88 5.83 17.88 5.84V8.77H17.87Z"
                fill="white"
              />
            </svg>

            <span className="ms-2 d-none d-lg-block">
              {!graphData ? "View Revenue Graph" : "Hide Revenue Graph"}{" "}
            </span>
            {!graphData ? (
              <svg
                className="arrow-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 8.3335L10.8838 12.1611C10.3977 12.6132 9.60227 12.6132 9.11616 12.1611L5 8.3335"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 11.6665L10.8838 7.83886C10.3977 7.38683 9.60227 7.38683 9.11616 7.83886L5 11.6665"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>

          )}
          
          <div className="searchBar">
            <div className="searchCross">
              <input
               id="search"
                autoComplete="off"
                type="text"
                className="form-control"
                placeholder="Search"
                name="search"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && searchInput) {
                    navigate("/app/globelsearch", {
                      state: { searchString: searchInput },
                    });
                  } else if (e.key === "Enter" && !searchInput) {
                    toastrService.showError("Please enter text to search");
                    return;
                  }
                }}
              />
              {searchInput && (
                <div className="d-flex align-items-center">
                  <label className="filter" onClick={deleteData}>
                  </label>
                  <img className="filter" src={searchinput} alt=""  style={{right: '12px', width: '20px', top: '50%', cursor: 'pointer'}} onClick={ () => navigate("/app/globelsearch", { state: { searchString: searchInput }})}/>
                </div>
              )}
            </div>
            <div className="credee_logo">
              <img src={Credee_Logo} alt=""   onClick={ () => navigate("/app/dashboard")}/>
            </div>
          </div>
          <div className="nav-bar-menu">
            
            <div className="">
              <img
                src={companyLogo}
                style={{ padding: "0px 0" }}
                alt="App Logo"
                width="125px"
                className="block-center img-responsive img-logo"
               
              />
              <div className="side-tabs">
                <div>
                  <button
                    btn-primary="true"
                    className="quiz_btn"
                    id="new-business"
                  >
                    <NavLink
                      style={{ color: "black" }}
                      to={"/app/new-business"}
                    >
                      {" "}
                      <span>+ Add New Business</span>
                    </NavLink>
                  </button>
                  <ul className="menu-items">
                    {!partnerInfo?.user_partner_info?.pu_id && (
                      <li>
                        <NavLink
                          className={({ isActive, isPending }) =>
                            isPending ? "pending" : isActive ? "active" : "item"
                          }
                          to={"/app/dashboard"}
                          id="dashboard"
                        >
                          {" "}
                          <img className="me-2" src={dashboard} />
                          <span id="DashBoard">Dashboard</span>
                        </NavLink>
                      </li>
                    )}

                    <li>
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending ? "pending" : isActive ? "active" : "item"
                        }
                        to={"/app/business"}
                        id="Businesses"
                      >
                        {" "}
                        <img className="me-2" src={businesses} />
                        <span id="Businesses">Businesses {countData && countData.total_business > 0 ? "(" + countData.total_business + ")" : '' }</span>
                      </NavLink>
                    </li>
                    {partnerInfo && partnerInfo?.show_agent_tab == 1 &&<li>
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending
                            ? "pending"
                            : isActive
                            ? "active"
                            : "item"
                        }
                        to={"/app/sub-partner"}
                        id="SubPartner"

                      >
                        <img className="me-2" src={subPartner} />
                        <span id="subPartner">Sub Partner {countData && countData.total_agents > 0 ? "(" + countData.total_agents + ")" : '' }</span>
                      </NavLink>
                    </li>}
                    {!partnerInfo?.user_partner_info?.pu_id && (
                      <>
                        {partnerInfo && partnerInfo?.show_user_tab == 1 && (
                          <li>
                            <NavLink
                              className={({ isActive, isPending }) =>
                                isPending
                                  ? "pending"
                                  : isActive
                                  ? "active"
                                  : "item"
                              }
                              to={"/app/users"}
                              id="Users"
                            >
                              {" "}
                              <img className="me-2" src={subPartner} />
                              <span id="users">Users</span>
                            </NavLink>
                          </li>
                        )}

                        <li>
                          <NavLink
                            className={({ isActive, isPending }) =>
                              isPending
                                ? "pending"
                                : isActive
                                ? "active"
                                : "item"
                            }
                            to={"/app/payout-reports"}
                            id="Commissions"

                          >
                            {" "}
                            <img className="me-2" src={PayoutReport} />
                            <span id="commissions">Commissions</span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive, isPending }) =>
                              isPending
                                ? "pending"
                                : isActive
                                ? "active"
                                : "item"
                            }
                            to={"/app/calculator"}
                            id="Calculator"

                          >
                            <img className="me-2" src={calculator} />
                            <span id="calculator">Calculator</span>
                          </NavLink>
                        </li>
                      </>
                    )}

                    <li>
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending ? "pending" : isActive ? "active" : "item"
                        }
                        to={"/app/support"}
                        id="Support"
                      >
                        {" "}
                        <img className="me-2" src={support} />
                        <span id="support">Support</span>
                      </NavLink>
                    </li>
                    {(
                      <li>
                        <NavLink
                          className={({ isActive, isPending }) =>
                            isPending ? "pending" : isActive ? "active" : "item"
                          }
                          to={"/app/courses"}
                        id="Courses"

                        >
                          {" "}
                          <img className="me-2" src={courses} />
                          <span id="courses">Courses</span>
                        </NavLink>
                      </li>
                    )}
                    {stripe && stripe.show_assets == 1 &&
                    <li>
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending ? "pending" : isActive ? "active" : "item"
                        }
                        to={"/app/assets"}
                        id="Assets"

                      >
                        {" "}
                        <img className="me-2" src={assets} />
                        <span id="assets">Assets</span>
                      </NavLink>
                    </li>
                    }

                    {/* <li>
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending ? "pending" : isActive ? "active" : "item"
                        }
                        to={"/app/training-list"}
                      >
                        {" "}
                        <img className="me-2" src={support} />
                        <span>Tranings</span>
                      </NavLink>
                    </li> */}
                  </ul>
                </div>

                <NavLink
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : "item"
                  }
                  to={"/app/profile"}
                  id="profile"
                >
                  <div className="main-profile">
                    <img
                      className="me-2 profile"
                      src={image ? image : dummy_profile_pic}
                    />
                    <div>
                      <span id="prof-name" className="content-wrap" translate="no">
                        {userData &&
                          userData.partner_profile &&
                          userData.partner_profile[0] &&
                          userData.partner_profile[0].partner_name}
                      </span>
                      {stripeData &&
                        (!stripeData["individual_address"] ||
                          !stripeData["individual_address"]["postal_code"] ||
                          !stripeData["individual_address"].line1) && (
                          <p className="missing">
                            <img src={missingInfo} alt="" />
                            Missing Info
                          </p>
                        )}
                    </div>
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      ) : // <div className="nav leftsidebar" style={{width: '7%', position: 'absolute'}} >
      //     <div className={"menu w-100 text-center p-3" + (activeRoute == routes.dashboard ? ' active' : '')}>
      //         <a onClick={() => updateActiveRoute(routes.dashboard)} href="#">Dashboard</a>
      //     </div>
      //     <div onClick={redirect2} className={"menu w-100 text-center p-3" + (activeRoute == routes.business ? ' active' : '')}>
      //     <a onClick={() => updateActiveRoute(routes.dashboard)} href="/dashboard">Business</a>
      //     </div>
      // </div>
      null}
      {/* <nav className="navbar topnavbar" role="navigation" style={{ backgroundImage: 'none', backgroundColor: '#023849', justifyContent: 'center' }}>
                <img src={"app/img/SVG/logo_white.svg"} style={{ padding: '5px 0' }} alt="App Logo" width="125px" className="block-center img-responsive img-logo" />
                </nav> */}
    </>
  );
};
export default Layout;
